import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const MarketsLayout = lazy(() => import('@/pages/markets/layout'));
const MarketDetailLayout = lazy(() => import('@/pages/markets/detail/layout'));
const MarketsListPage = lazy(() => import('@/pages/markets'));
const MarketCreatePage = lazy(() => import('@/pages/markets/create'));
const MarketDetailIndexPage = lazy(() => import('@/pages/markets/detail'));
const MarketOverviewPage = lazy(() => import('@/pages/markets/detail/overview'));
const MarketUpdatePage = lazy(() => import('@/pages/markets/detail/update'));
const MarketUsersListPage = lazy(() => import('@/pages/markets/detail/users'));
const MarketClientsListPage = lazy(() => import('@/pages/markets/detail/clients'));
const MarketAwaTemplatePage = lazy(() => import('@/pages/markets/detail/awaTemplate'));
const MarketHistoryPage = lazy(() => import('@/pages/markets/detail/history'));

/**
 * UG-4501 — market entity routes (legacy `app/(dashboard)/markets/*`).
 * `MarketsLayout` mounts the section breadcrumb; `MarketDetailLayout` is the
 * legacy `[marketId]/layout.tsx` shell (market fetch + header + sub-nav)
 * around every nested view. Permissions: `@/config/auth/routeAccess`
 * (ported 1:1 from the legacy table).
 */
export const marketRoutes: RouteConfig = {
  path: '/markets',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: MarketsLayout,
      children: [
        { path: '', element: MarketsListPage },
        { path: '/create', element: MarketCreatePage },
        {
          path: '/:marketId',
          layout: MarketDetailLayout,
          children: [
            { path: '', element: MarketDetailIndexPage },
            { path: '/overview', element: MarketOverviewPage },
            { path: '/update', element: MarketUpdatePage },

            { path: '/users', element: MarketUsersListPage },
            { path: '/clients', element: MarketClientsListPage },

            { path: '/awaTemplate', element: MarketAwaTemplatePage },
            { path: '/history', element: MarketHistoryPage },
          ],
        },
      ],
    },
  ],
};
